"use client";

// delegate-shell-theme
// Starts the shell theme bridge at module scope, so the cached theme and the
// provisional embed layout are applied before hydration and the first
// `delegate-meet:theme-ready` leaves before React renders (THEME.md 1.1, 9.3).
// Rendered once as the first child of <body> in app/layout.tsx. Standalone
// Meet (not framed at meet.<shell host>) leaves the bridge fully inert.
import { startShellThemeBridge } from "./theme-bridge";

if (typeof window !== "undefined") startShellThemeBridge();

export function DelegateShellBoot(): null {
  return null;
}

export default DelegateShellBoot;
